<template>
  <div class="course-manage-page">
    <el-card>
      <el-form :model="filter" inline size="small">
        <el-form-item label="课程名称">
          <el-input v-model="filter.name" placeholder="请输入课程名称" clearable/>
        </el-form-item>
        <el-form-item label="课程类型">
          <el-select v-model="filter.type" placeholder="请选择职业方向类型" clearable>
            <el-option label="基础必学课程" :value="1" />
            <el-option label="职业方向课程" :value="2" />
            <el-option label="实操考核课程" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-button type="primary" size="small" style="margin-bottom: 10px;" @click="add">新增课程</el-button>
      <el-table :data="courseList" border>
        <el-table-column align="center" label="课程名称" prop="name" />
        <el-table-column align="center" label="课程类型" prop="type">
          <template v-slot="{ row: { type } }">
            <span v-if="type === 1">基础必学课程</span>
            <span v-else-if="type === 2">职业方向课程</span>
            <span v-else-if="type === 3">实操考核课程</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="已关联课时数量" prop="lesperiodTotal" />
        <el-table-column align="center" label="更新时间" prop="lastUpdateDate" min-width="100" />
        <el-table-column align="center" label="最后操作人" prop="updateByUserName" min-width="100" />
        <el-table-column align="center" label="操作" min-width="100">
          <template v-slot="{ row }">
            <el-button type="text" @click="edit(row)">编辑</el-button>
            <el-button type="text" @click="viewChapter(row)">查看章节</el-button>
            <el-button type="text" @click="viewHour(row)">查看课时</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <!-- 新增 / 编辑 课程 -->
    <el-dialog :title="title" :visible.sync="courseDialogVisible" width="880px" :before-close="handleClose">
      <el-form :model="courseManage" :rules="rules" ref="courseManageForm" label-width="110px" size="small">
        <el-form-item label="课程名称" prop="name">
          <el-input v-model="courseManage.name" maxlength="50" placeholder="请输入课程名称" />
        </el-form-item>
        <el-form-item label="课程类型" prop="type">
          <el-select v-model="courseManage.type" placeholder="请选择课程类型" clearable @change="handleChangeType">
            <el-option label="基础必学课程" :value="1" />
            <el-option label="职业方向课程" :value="2" />
            <el-option label="实操考核课程" :value="3" />
          </el-select>
        </el-form-item>
        <template v-if="courseManage.type === 2">
          <el-form-item label="课程简介" prop="summary">
            <el-input v-model="courseManage.summary" placeholder="请输入课程简介" />
          </el-form-item>
          <el-form-item label="课程介绍" prop="introduce">
            <QuillEditor v-model="courseManage.introduce" />
          </el-form-item>
        </template>
        <template v-if="courseManage.type === 3">
          <el-form-item label="课程预约时间" prop="timer">
            <el-date-picker
              v-model="courseManage.timer"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item label="预约人数上限" prop="appointmentNum">
            <el-row type="flex">
              <el-input-number v-model="courseManage.appointmentNum" placeholder="请输入预约人数上限" :max="999" :controls="false" />
              <span>（人）</span>
            </el-row>
          </el-form-item>
          <el-form-item label="实操批次名称" prop="batchName">
            <el-input v-model="courseManage.batchName" placeholder="请输入实操批次名称" />
          </el-form-item>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button type="primary" size="small" @click="submit('courseManageForm')">确 定</el-button>
      </span>
    </el-dialog>

    <CourseChapter ref="chapterEl" @close="getList" />
    <CourseHour ref="hourEl" @close="getList" />
  </div>
</template>

<script>
import CourseChapter from './components/CourseChapter.vue';
import CourseHour from './components/CourseHour.vue';
import QuillEditor from "@/components/QuillEditor/index.vue";
import {
  getPageList,
  addCourse,
  updateCourse,
} from '@/api/product/courseManage'

export default {
  name: 'CourseManage',

  components: { CourseHour, CourseChapter, QuillEditor },
  data() {
    return {
      filter: {
        page: 1,
        limit: 10,
        name: null,
        type: null
      },
      total: 0,
      courseList: [],
      title: '',
      courseDialogVisible: false,
      editId: null,
      courseManage: {
        name: null,
        type: null,
        summary: null,
        introduce: null,
        timer: null,
        appointmentNum: undefined,
        batchName: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入课程名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请输入课程类型', trigger: 'change' }
        ],
        summary: [
          { required: true, message: '请输入课程简介', trigger: 'blur' }
        ],
        introduce: [
          { required: true, message: '请输入课程介绍', trigger: 'blur' }
        ],
        timer: [
          { required: true, message: '请选择课程预约时间', trigger: 'blur' }
        ],
        appointmentNum: [
          { required: true, message: '请输入预约人数上限', trigger: 'blur' }
        ],
        batchName: [
          { required: true, message: '请输入实操批次名称', trigger: 'blur' }
        ],
      }
    }
  },

  created() {
    this.getList()
  },
  methods: {
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      this.filter = this.$options.data().filter
      this.getList()
    },
    getList() {
      getPageList(this.filter).then(({ code, data, message }) => {
        if (code === 0) {
          this.courseList = data.records
          this.total = parseInt(data.total, 10)
        } else {
          this.$message.error(message)
        }
      })
    },
    // 点击添加课程
    add () {
      this.title = '新增课程'
      this.courseDialogVisible = true
    },
    // 点击编辑课程
    edit (row) {
      this.editId = row.id
      this.title = '编辑课程'
      this.courseDialogVisible = true
      this.courseManage = {
        name: row.name,
        type: row.type,
        summary: row.summary,
        introduce: row.introduce,
        timer: [],
        appointmentNum: row.appointmentNum,
        batchName: row.batchName
      }
      if (row.beginDate && row.endDate) {
        this.courseManage.timer = [row.beginDate, row.endDate]
      }
    },
    // 切换课程类型
    handleChangeType(e) {
      if (e !== 2) {
        this.courseManage.summary = ''
        this.courseManage.introduce = ''
      } else if(e !== 3) {
        this.courseManage.timer = null
        this.courseManage.appointmentNum = undefined
        this.courseManage.batchName = ''
      }
    },
    // 新增/编辑 提交
    submit(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const params = { ...this.courseManage }
          switch (params.type) {
            case 1:
              delete params.summary
              delete params.introduce
              delete params.appointmentNum
              delete params.batchName
              break
            case 2:
              delete params.appointmentNum
              delete params.batchName
              break
            case 3:
              delete params.summary
              delete params.introduce
              break
          }
          if (params.timer && params.timer.length !== 0) {
            params.beginDate = params.timer[0]
            params.endDate = params.timer[1]
          }
          delete params.timer
          if (!this.editId) {
            addCourse(params)
              .then(({ code }) => {
                if (code === 0) {
                  this.$message.success('新增课程成功!')
                  this.handleClose()
                  this.getList()
                }
              })
          } else {
            updateCourse({ id: this.editId, ...params })
              .then(({ code }) => {
                if (code === 0) {
                  this.$message.success('编辑课程成功!')
                  this.handleClose()
                  this.getList()
                }
              })
          }
        }
      })
    },
    // 上下架操作
    statusAmend(row) {
      let operateStatus = ''
      let publishFlag = 1
      switch (row.publishFlag) {
        case 1:
          operateStatus = '上架'
          publishFlag = 2
          break
        case 2:
          operateStatus = '下架'
          publishFlag = 1
          break
      }
      this.$confirm(`确认${operateStatus}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await updateCourse({ id: row.id, publishFlag })
        if (res.code !== 0) return this.$message.error(res.message)
        this.$message.success(`${operateStatus}成功!`)
        this.getList()
      })
    },
    // 查看课时
    viewHour(row) {
      this.$refs.hourEl.show(row)
    },
    // 查看章节
    viewChapter(row) {
      this.$refs.chapterEl.show(row.id)
    },
    handleClose() {
      this.editId = null
      this.courseManage = this.$options.data().courseManage
      this.$refs.courseManageForm && this.$refs.courseManageForm.resetFields()
      this.courseDialogVisible = false
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    }
  },
}
</script>

<style>

</style>
